<template>
<div class="card card-dashboard-fourteen mg-t-10" style="width:100%;height:288px;margin-left:10px;margin-right:10px" v-loading='loading'>
    <label class="az-content-label">Pension 
        <span>{{fy}}</span>
    </label>
    
    <div class="card-body" v-show="!isShow">
        <div class="card bd-0 mg-t-5" style="height:100%;">
            <div class="card-header bd bd-b-0 tx-medium tx-black">
                {{title_detail}}
                <!-- <input v-model="message" placeholder="test"> -->
                <button type="button" class="close" aria-label="Close" style="float:right">
                    <span aria-hidden="true" @click="isShow = !isShow">&times;</span>
                </button>
            </div><!-- card-header -->
            <div class="card-body bd bd-t-0">
                <div class="table-responsive" style="height:140px" >
                    <table class="table mg-b-0" style="table-layout:fixed">
                        <thead>
                            <tr>
                                <th>Fund</th>
                                <th>Member</th>
                                <th width=20% v-show="title_detail.includes('PENSION')|title_detail.includes('MEMBERS')">{{th}}</th>
                            </tr>
                        </thead>
                        <tbody v-show="title_detail.includes('PENSION')">
                            <tr v-for='(pension,index) in minPensions' :key='index'>
                                <td class="tx-medium">
                                    <router-link :to="{path:'/funddashboard/'+pension.trustee__smsf__fund_code,query:{name:pension.trustee__smsf__fund_name}}">
                                        {{isSample?'Sample Family Super Fund '+(index+1):pension.trustee__smsf__fund_name}}
                                    </router-link>
                                </td>
                                <td>
                                    <router-link :to="{path:'/funddashboard/'+pension.trustee__smsf__fund_code+'/memberbasic/',query:{name:pension.trustee__smsf__fund_name,page:'Member Basic Details'}}">
                                        {{isSample?'Mr Mike Sample '+(index+1):pension.trustee__trustee_name}}
                                    </router-link>
                                </td>
                                <td>{{isSample?'Sample Account '+(index+1):pension.account_name}}</td>
                            </tr>
                        </tbody>
                        <tbody v-show="title_detail.includes('MEMBERS')">
                            <tr v-for='(trustee,index) in trustees_p' :key='index'>
                                <td class="tx-medium">
                                    <router-link :to="{path:'/funddashboard/'+trustee.smsf__fund_code,query:{name:trustee.smsf__fund_name}}">
                                        {{isSample?'Sample Family Super Fund '+(index+1):trustee.smsf__fund_name}}
                                    </router-link>
                                </td>
                                <td>
                                    <router-link :to="{path:'/funddashboard/'+trustee.smsf__fund_code+'/memberbasic/',query:{name:trustee.smsf__fund_name,page:'Member Basic Details'}}">
                                        {{isSample?'Mr Mike Sample '+(index+1):trustee.trustee_name}}
                                    </router-link>
                                </td>
                                <td>{{trustee.age}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div><!-- table-responsive -->
            </div><!-- card-body -->
        </div><!-- card -->
    </div>
        
    <div class="card-body" v-show="isShow">
        <div class="row mg-t-15 mg-b-20">
            <div class="col-6">
                <h4 style="font-size: 20px;">{{minpensionsLen}} 
                    <a style="font-size:18px;color:gray" @click="minpensionsLen>0 && showDetail('minPension')" role="button" aria-expanded="false"><i class="fa fa-file-text"></i></a>
                </h4>
                <label class="label-custom">{{minpensionsLen>1?'Pension accounts':'Pension account'}}</label>
                <div style="height:42px">
                    <span>have not reached the minimum pension limit</span>
                </div>
                <div class="progress mg-t-5 ht-5">
                    <div class="progress-bar" :style="{'width':minpensionsPer+'%'}" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <small>{{minpensionsPer}}% of pension accounts</small>
            </div><!-- col -->
            <div class="col-6">
                <h4 style="font-size: 20px;">{{trustees_pLen}} 
                    <a style="font-size:18px;color:gray" @click="trustees_pLen>0 && showDetail('Member')" role="button" aria-expanded="false"><i class="fa fa-file-text"></i></a>
                </h4>
                <label class="label-custom">{{trustees_pLen>1?'Members':'Member'}}</label>
                <div style="height:42px">
                    <span>have not commenced a pension but met the preservation age</span>
                </div>
                <div class="progress mg-t-5 ht-5">
                    <div class="progress-bar bg-teal" :style="{'width':trustees_pPer+'%'}" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <small>{{trustees_pPer}}% of members</small>
            </div><!-- col -->
        </div><!-- row -->
    </div><!-- card-body -->
    <div class="card-footer">
        <el-select style="width:120px;margin-right:10px" size='mini' clearable v-model="b" placeholder="Select Brand">
            <el-option v-for="(brand,index) in brands" :key="index" :label="brand[1]" :value="brand"></el-option>
        </el-select>
        <span style="font-size:12px;font-weight:600">
            <el-tooltip v-if="b===''" class="item" effect="dark" content="Select a brand to view the Minimum Pension Status" placement="top">
                <span class="nav-sub-link"><i class="fa fa-angle-right"></i>Minimum Pension Status</span>
            </el-tooltip>
            <router-link v-else class="nav-sub-link" :to='{path:"/adviserdashboard/min_pension",query:{page:"Minimum Pension Status"}}'>
                <i class="fa fa-angle-right"></i>Minimum Pension Status
            </router-link>
        </span>
    </div>
</div><!-- card -->
</template>
<script>
import dateformats from "../../../utils/dateformats"
export default {
    name:'pension',
    components: { 
        
    },
    data(){
        return{
            brands:[],
            b:'',
            isSample:false,
            fy: '('+dateformats.getFinancialYear()+')',
            minPensions:[],
            minpensionsLen:'',
            minpensionsPer:'',
            trustees_p:[],
            trustees_pLen:'',
            trustees_pPer:'',
            isShow:true,
            title_detail:'',
            th:'',
            loading:true
        
        }
    },
    created(){
        this.getPensionData();
    },
    watch:{
        b(newVal){
            if(newVal !== ''){
                this.$store.dispatch('select_brand',newVal)
            }
        }
    },
    methods:{
        getPensionData: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.brands = userdetail['brand_list']
            let brand = localStorage.getItem('brand_code')
            this.isSample = userdetail['sample'];
            this.$api.bo_api.pension(brand).then(response =>{
                //get the investments data from response
                this.minPensions = response.data["minpensions"];
                this.minpensionsLen = this.minPensions.length;
                this.minpensionsPer = response.data["per_minpensions"];
                this.trustees_p = response.data["trustees_p"];
                this.trustees_pLen = this.trustees_p.length;
                this.trustees_pPer = response.data['per_trustees']
                this.loading=false
            });
        },
        showDetail(title){
            this.isShow = !this.isShow
            if(title==='minPension'){
                this.title_detail = 'PENSION ACCOUNTS have not reached the minimum pension limit' 
                this.th='Account'
            }else if(title==='Member'){
                this.title_detail = 'MEMBERS have not commenced a pension but met the preservation age'
                this.th='Age'
            }
            
        }
    }
}
</script>
<style scoped>
.label-custom{
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 0;
    display: block;
    letter-spacing: .5px;
}
</style>